<template>
  <section class="container columns" style="margin: 2% auto">
    <form v-on:submit.prevent="createCropType" class="column is-half">
      <b-field label="Crop Name">
        <b-input
          v-model="newCropType.cropTypeName"
          placeholder
          required
        ></b-input>
      </b-field>
      <div>
        <button class="button is-primary" type="submit">Create</button>
      </div>
    </form>
  </section>
</template>

<script>
import { currencies } from "@/helpers";
import { mapGetters } from "vuex";
export default {
  name: "newCropType",
  data() {
    return {
      newCropType: {
        cropTypeName: ""
      }
    };
  },
  created() {},
  methods: {
    createCropType() {
      const loading = this.$loading.open();

      this.$store
        .dispatch("createCropType", this.newCropType)
        .then(newCropType => {
          loading.close();
          this.$router.push({ cropTypeName: "Crop Type Names" });
          this.$toasted.global.success("Crop Type Successfully Created!");
        })
        .catch(e => {
          console.log("Exception when creating new Crop Type", e);
          loading.close();
          this.$toasted.global.error("Failed to create crop Type.");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CropManager/NewCropType.vue